import { Body3 } from '../../themes/typography';

export default function SpanTag({ eventFormatTag = 'Music' }) {
    return (
        <span style={styles.span}>
            <Body3
                fontWeight={500}
                color="#26C1E8"
                style={{
                    // lineHeight: '1.2',
                    margin: '5px'
                }}
            >
                {eventFormatTag}
            </Body3>
        </span>
    );
}

const styles = {
    span: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        textAlign: 'center',
        border: '1px solid #f5f5f5',
        padding: '0px 8px',
        minHeight: '24px',
        maxHeight: '44px',
        borderRadius: '1.5rem',
        boxSizing: 'border-box',
        textTransform: 'capitalize'
    }
};